var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/NodeExpand/NodeExpand.tsx";
import { Shevron } from '@gmini/ui-kit/lib/icons';
import { ExpandButton, ExpandDot, ExpandDotWrap, ShevronWrapper } from "./NodeExpand.styled";
import { jsx as _jsx } from "react/jsx-runtime";
export var NodeExpand = function NodeExpand(_ref) {
  var expanded = _ref.expanded,
      onClick = _ref.onClick,
      hidden = _ref.hidden,
      unavailable = _ref.unavailable,
      hovered = _ref.hovered;

  if (unavailable) {
    return /*#__PURE__*/_jsx(ExpandDotWrap, {
      children: /*#__PURE__*/_jsx(ExpandDot, {})
    });
  }

  return /*#__PURE__*/_jsx(ExpandButton, {
    onClick: onClick,
    "data-test-item-expanded": expanded,
    "data-test-id": "toggle",
    hide: hidden,
    children: /*#__PURE__*/_jsx(ShevronWrapper, {
      expanded: expanded,
      hovered: hovered,
      children: /*#__PURE__*/_jsx(Shevron, {})
    })
  });
};